const Registration = Object.freeze({
  lookup: 'start',
  registration: 'step 2',
  complete: 'complete'
})

export default Registration
